module.exports = __webpack_public_path__ + "static/media/maxrozen_profile_square.387fc1b5.jpg";